import React, { useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import ReactDOM from 'react-dom';
import { ActionIcon, Anchor, Text, Modal,  } from '@mantine/core';
import { IconHelp, IconInfoCircle, IconX } from '@tabler/icons-react';
import TestsApi from "../../api/TestsApi";
import { notifications } from '@mantine/notifications';
import { SelectTooltip } from "../../components/GeneralComponent/GeneralComponent";

export function TestInfo({ pageId }:any) {
  const navigate = useNavigate();
  const [testInfoModalOpen, setTestInfoModalOpen] = useState(false);
  const [testInfoPageLink, setTestInfoPageLink] = useState('');
  const [testInfoPageTitle, setTestInfoPageTitle] = useState('');
  const [testInfoTestTime, setTestInfoTestTime] = useState('');
  const [testInfoOriginalLaunch, setTestInfoOriginalLaunch] = useState('');
  const [testInfoTestType, setTestInfoTestType] = useState('');
  const [testInfoVisioptTestId, setTestInfoVisioptTestId] = useState('');
  const [testsName, setTestsName] = useState('');

  const testInfoRef = useRef(null);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [helpTargetId, setHelpTargetId] = useState(0);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });

  const handleTestInfoOpenModal = (value:any) => {
    if (!pageId) {
      navigate('/review-tests');
      return;
    }
    TestsApi.gettestinfo({
      page_id:pageId
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if (data.status === 1) {
        setTestInfoPageLink(data.data.page_link);
        setTestInfoPageTitle(data.data.page_title);
        setTestInfoTestTime(data.data.test_time);
        setTestInfoOriginalLaunch(data.data.original_launch_date || '');
        setTestInfoTestType(data.data.test_type);
        setTestInfoVisioptTestId(data.data.visiopt_test_id);
        setTestsName(data.data.tests_name);
        setTestInfoModalOpen(true);
      } else {
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
      }
    })
    .catch(error => {
      console.error("API Error:", error);
    });
  };

  const handleTestInfoCloseModal = () => {
    setTestInfoModalOpen(false);
  };

  const handleHelpClick = (id:any) => {
    setShowHelpModal(true);
    setHelpTargetId(id);
    if (testInfoRef.current) {
      const { top, left, width } = testInfoRef.current.getBoundingClientRect();
      const scrollOffset = window.scrollY;
      setTooltipPosition({
        top: top + scrollOffset,
        left: left + width + 10, 
      });
    }
  };

  return (
    <>
    {showHelpModal &&
      ReactDOM.createPortal(
        <div style={{ zIndex: 9999 }}>
          <SelectTooltip
            isVisible={showHelpModal}
            setIsVisible={setShowHelpModal}
            id={helpTargetId}
            tooltipPosition={tooltipPosition}
          />
        </div>,
        document.body
      )}
      <ActionIcon
        variant="default"
        size="lg"
        sx={(theme) => ({
           backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : "#fff",
         })}
        title="Test Info"
        ml={5}
        onClick={() => handleTestInfoOpenModal(1)}
      >
        <IconInfoCircle size="1.1rem" />
      </ActionIcon>     
 
      <Modal.Root opened={testInfoModalOpen} onClose={handleTestInfoCloseModal} trapFocus={false}>
        <Modal.Overlay />
        <Modal.Content>
          <Modal.Header>
            <Modal.Title><Text weight={500}>TEST INFORMATION <IconHelp ref={testInfoRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={() => handleHelpClick(203)}/></Text></Modal.Title>
            <Modal.CloseButton />
          </Modal.Header>
          <Modal.Body>
            <form>
              <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 6 }}>
                <Text size="sm" fz={14} fw={500} mr={5} style={{ minWidth: 100 }}>Test ID:</Text>
                <Text size="sm" fz={14}>{testInfoVisioptTestId}</Text>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 6 }}>
                <Text size="sm" fz={14} fw={500} mr={5} style={{ minWidth: 100 }}>Test Name:</Text>
                <Text size="sm" fz={14} mr={5}>{testsName}</Text>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 6 }}>
                <Text size="sm" fz={14} fw={500} mr={5} style={{ minWidth: 100 }}>Tested Page:</Text>
                <Anchor href={testInfoPageLink} target="_blank" fw={500} mr={5} mt={-2}>{testInfoPageTitle} </Anchor>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 6 }}>
                <Text size="sm" fz={14} fw={500} mr={5} style={{ minWidth: 100 }}>Test Type:</Text>
                <Text size="sm" fz={14} mr={5}>{testInfoTestType}</Text>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 6 }}>
                <Text size="sm" fz={14} fw={500} mr={5} style={{ minWidth: 100 }}>Test Start on:</Text>
                <div>
                  <Text size="sm" fz={14}>{testInfoTestTime}</Text>
                  {testInfoOriginalLaunch !== '' && (
                    <Text size="xs" fz={12} c="dimmed" mt={2}>
                      Originally launched {testInfoOriginalLaunch} · Reset on {testInfoTestTime}
                    </Text>
                  )}
                </div>
              </div>
            </form>
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>      
    </>
  );
}